var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragPan = function SvgDragPan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21.654 8.096 17.75l1.07-1.07 2.084 2.085V12.75h-6l2.085 2.07-1.085 1.084L2.346 12l3.888-3.889 1.07 1.07-2.07 2.069h6.016V5.235L9.165 7.319 8.096 6.25 12 2.346l3.904 3.904-1.07 1.07-2.084-2.086v6.016h6l-2.084-2.07 1.084-1.084L21.654 12l-3.904 3.904-1.07-1.07 2.085-2.084H12.75v6l2.07-2.084 1.084 1.084z"
  })));
};
export default SvgDragPan;